// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ======================
   ComposerModal — landing prompt box in a modal + "agent started" state
   The prompt box itself reuses the global .landing-* / .ar-* / .mt-* classes.
   ====================== */

.cm-overlay {
  position: fixed;
  inset: 0;
  z-index: 1100; /* above the analysis modal */
  background: rgba(0, 0, 0, 0.66);
  backdrop-filter: blur(3px);
  animation: cm-fade 0.15s ease;
}

.cm-content {
  position: fixed;
  z-index: 1101;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: min(580px, 94vw);
  background: var(--color-bg-root);
  border: 1px solid var(--color-border-input);
  border-radius: 14px;
  padding: 16px;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.45);
  animation: cm-pop 0.16s ease;
}

@keyframes cm-fade {
  from { opacity: 0; }
}

@keyframes cm-pop {
  from { opacity: 0; transform: translate(-50%, -48%) scale(0.98); }
}

.cm-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.cm-title {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: var(--color-text-primary);
}

.cm-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 7px;
  border: none;
  background: transparent;
  color: var(--color-text-secondary);
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.cm-close:hover:not(:disabled) {
  background: var(--color-bg-input);
  color: var(--color-text-primary);
}

.cm-close:disabled {
  opacity: 0.4;
  cursor: default;
}

/* Make the reused landing panel sit flush inside the modal */
.cm-content .landing-upload-panel {
  width: 100%;
  box-sizing: border-box;
  margin: 0;
}

/* The aspect/model dropdowns portal to <body>; lift them above the modal. */
.ar-content.cm-dropdown,
.mt-content.cm-dropdown {
  z-index: 1200;
}

.cm-error {
  margin-top: 12px;
  padding: 9px 12px;
  border-radius: 6px;
  background: rgba(220, 38, 38, 0.08);
  border: 1px solid rgba(220, 38, 38, 0.25);
  color: #dc2626;
  font-size: 12.5px;
}

/* ── "Agent started" state ── */
.cm-started {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 8px 8px 4px;
}

.cm-started-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  border-radius: 50%;
  background: var(--color-bg-input);
  border: 1px solid var(--color-border-input);
  color: var(--color-text-secondary);
  margin-bottom: 12px;
}

.cm-started-title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: var(--color-text-primary);
}

.cm-started-sub {
  margin: 6px 0 18px;
  font-size: 13px;
  line-height: 1.5;
  color: var(--color-text-secondary);
  max-width: 380px;
}

/* Watch button with a background fill that drains over the timer */
.cm-watch-btn {
  position: relative;
  overflow: hidden;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 46px;
  border: 1px solid var(--color-border-input);
  border-radius: 10px;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-size: 14px;
  font-weight: 700;
  font-family: inherit;
  cursor: pointer;
}

.cm-watch-btn:hover {
  border-color: var(--color-text-secondary);
}

.cm-watch-fill {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 0;
  background: rgba(127, 127, 127, 0.18);
  animation: cm-fill 10s linear forwards;
}

.cm-watch-label {
  position: relative;
  z-index: 1;
}

@keyframes cm-fill {
  from { width: 0; }
  to { width: 100%; }
}

.cm-started-hint {
  margin: 10px 0 0;
  font-size: 11.5px;
  color: var(--color-text-secondary);
  opacity: 0.8;
}

.cm-spin {
  animation: cm-spin 0.9s linear infinite;
}

@keyframes cm-spin {
  to { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/components/ComposerModal.css"],"names":[],"mappings":"AAAA;;;2BAG2B;;AAE3B;EACE,eAAe;EACf,QAAQ;EACR,aAAa,EAAE,6BAA6B;EAC5C,+BAA+B;EAC/B,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,uBAAuB;EACvB,gCAAgC;EAChC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,2CAA2C;EAC3C,4BAA4B;AAC9B;;AAEA;EACE,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,OAAO,UAAU,EAAE,4CAA4C,EAAE;AACnE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,6DAA6D;AAC7D;EACE,WAAW;EACX,sBAAsB;EACtB,SAAS;AACX;;AAEA,4EAA4E;AAC5E;;EAEE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;EACd,iBAAiB;AACnB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,2CAA2C;EAC3C,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA,mEAAmE;AACnE;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,mBAAmB;EACnB,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,OAAO,QAAQ,EAAE;EACjB,KAAK,WAAW,EAAE;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC","sourcesContent":["/* ======================\n   ComposerModal — landing prompt box in a modal + \"agent started\" state\n   The prompt box itself reuses the global .landing-* / .ar-* / .mt-* classes.\n   ====================== */\n\n.cm-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1100; /* above the analysis modal */\n  background: rgba(0, 0, 0, 0.66);\n  backdrop-filter: blur(3px);\n  animation: cm-fade 0.15s ease;\n}\n\n.cm-content {\n  position: fixed;\n  z-index: 1101;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: min(580px, 94vw);\n  background: var(--color-bg-root);\n  border: 1px solid var(--color-border-input);\n  border-radius: 14px;\n  padding: 16px;\n  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.45);\n  animation: cm-pop 0.16s ease;\n}\n\n@keyframes cm-fade {\n  from { opacity: 0; }\n}\n\n@keyframes cm-pop {\n  from { opacity: 0; transform: translate(-50%, -48%) scale(0.98); }\n}\n\n.cm-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n\n.cm-title {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--color-text-primary);\n}\n\n.cm-close {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 7px;\n  border: none;\n  background: transparent;\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.cm-close:hover:not(:disabled) {\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n}\n\n.cm-close:disabled {\n  opacity: 0.4;\n  cursor: default;\n}\n\n/* Make the reused landing panel sit flush inside the modal */\n.cm-content .landing-upload-panel {\n  width: 100%;\n  box-sizing: border-box;\n  margin: 0;\n}\n\n/* The aspect/model dropdowns portal to <body>; lift them above the modal. */\n.ar-content.cm-dropdown,\n.mt-content.cm-dropdown {\n  z-index: 1200;\n}\n\n.cm-error {\n  margin-top: 12px;\n  padding: 9px 12px;\n  border-radius: 6px;\n  background: rgba(220, 38, 38, 0.08);\n  border: 1px solid rgba(220, 38, 38, 0.25);\n  color: #dc2626;\n  font-size: 12.5px;\n}\n\n/* ── \"Agent started\" state ── */\n.cm-started {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 8px 8px 4px;\n}\n\n.cm-started-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 46px;\n  height: 46px;\n  border-radius: 50%;\n  background: var(--color-bg-input);\n  border: 1px solid var(--color-border-input);\n  color: var(--color-text-secondary);\n  margin-bottom: 12px;\n}\n\n.cm-started-title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--color-text-primary);\n}\n\n.cm-started-sub {\n  margin: 6px 0 18px;\n  font-size: 13px;\n  line-height: 1.5;\n  color: var(--color-text-secondary);\n  max-width: 380px;\n}\n\n/* Watch button with a background fill that drains over the timer */\n.cm-watch-btn {\n  position: relative;\n  overflow: hidden;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 46px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 10px;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-size: 14px;\n  font-weight: 700;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.cm-watch-btn:hover {\n  border-color: var(--color-text-secondary);\n}\n\n.cm-watch-fill {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: 0;\n  background: rgba(127, 127, 127, 0.18);\n  animation: cm-fill 10s linear forwards;\n}\n\n.cm-watch-label {\n  position: relative;\n  z-index: 1;\n}\n\n@keyframes cm-fill {\n  from { width: 0; }\n  to { width: 100%; }\n}\n\n.cm-started-hint {\n  margin: 10px 0 0;\n  font-size: 11.5px;\n  color: var(--color-text-secondary);\n  opacity: 0.8;\n}\n\n.cm-spin {\n  animation: cm-spin 0.9s linear infinite;\n}\n\n@keyframes cm-spin {\n  to { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
